import React from "react";

import { ROUTES, useMediaQueries } from "../../shared";
import DesktopDetails from "./components/DesktopDetails/DesktopDetails";
import DetailsContent from "./components/DetailsContent/DetailsContent";
import MobileDetails from "./components/MobileDetails/MobileDetails";

interface DetailsSectionProps {
  route: ROUTES;
}

const DetailsSection = ({ route }: DetailsSectionProps) => {
  const { toMd } = useMediaQueries();

  return toMd ? (
    <MobileDetails route={route}>
      <DetailsContent route={route} />
    </MobileDetails>
  ) : (
    <DesktopDetails route={route} />
  );
};

export default React.memo(DetailsSection);
